import React from "react";
import { FaFacebook, FaGithub } from "react-icons/fa";

const Footer = () => {
    return (
        <footer className="bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-300 py-6 transition-all">
            <div className="container mx-auto px-6 md:px-12 lg:px-20 text-center">
                {/* ✅ Footer Title */}
                <h3 className="text-lg font-semibold mb-2">Let&apos;s Connect</h3>

                {/* ✅ Social Links (Only One GitHub Icon Here) */}
                <div className="flex justify-center space-x-6 mb-4">
                    <a
                        href="https://github.com/abdellah-ouffa"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-all text-2xl"
                    >
                        <FaGithub aria-label="GitHub Profile" />
                    </a>
                    <a
                        href="https://www.facebook.com/aouffa1"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-800 dark:hover:text-blue-400 transition-all text-2xl"
                    >
                        <FaFacebook aria-label="Facebook Profile" />
                    </a>
                </div>

                {/* ✅ Copyright Notice */}
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-16 sm:mb-0">
                    © {new Date().getFullYear()} Abdellah Ouffa. All Rights Reserved.
                </p>
            </div >
        </footer >
    );
};

export default Footer;